


















































import { Component, Vue } from "vue-property-decorator";

@Component
export default class Menu extends Vue {
  private menuItemList: object[] = [
    {
      text: "首页/Home",
      enText: "Home",
      target: "/Home"
    },
    {
      text: "科研/Research",
      enText: "Research",
      target: "/Research"
    },
    {
      text: "论文/Publications",
      enText: "Publications",
      target: "/Publications"
    },
    {
      text: "学生/Students",
      enText: "Students",
      target: "/Students"
    },
    {
      text: "图集/Gallery",
      enText: "Gallery",
      target: "/Gallery"
    }
  ];

  private subMenuButton: boolean = false;

  mounted() {
    if (document.documentElement.clientWidth < 640) {
      this.$store.commit("changeMobile");
    }
  }
  handleChangeLanguage() {
    this.$store.commit("changeLanguage");
  }

  handleSubMenuButtonClick() {
    this.subMenuButton = !this.subMenuButton;
  }

  handleSubMenuMouseOut() {
    if (this.subMenuButton) {
      this.subMenuButton = false;
    }
  }
}
